import React from 'react'
import { useSelector } from 'react-redux'
import VectorLayer from '../Layers/VectorLayer'
import { baseUrl } from "../../config"

const MapLayer = ({ isVisibly, children }) => {
    if (isVisibly) {
        return children
    }
    return null
}

export default function BaseMaps() {
    const activeMapLayers = useSelector((state) => state.mapStates.activeMapLayers)
    return (
        <MapLayer isVisibly={activeMapLayers.some(layer => layer === "countryBorder")}>
            <VectorLayer
                url={`${baseUrl}/data/countries.geojson`}
                zIndex={3}
            ></VectorLayer>
        </MapLayer>
    )
}
